var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIconRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.392,
    height: 34.392,
    viewBox: "0 0 34.392 34.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189802",
    "data-name": "Group 189802",
    transform: "translate(-909 -190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_42725",
    "data-name": "Path 42725",
    transform: "translate(909 190)",
    fill: "#ffe5e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.19580078125 33.3916015625 C 12.86974048614502 33.3916015625 8.802620887756348 31.70694160461426 5.743640899658203 28.6479606628418 C 2.684660673141479 25.58898162841797 1.000000834465027 21.52186012268066 1.000000834465027 17.19580078125 C 1.000000834465027 12.86974048614502 2.684660673141479 8.802620887756348 5.743640899658203 5.743640899658203 C 8.802620887756348 2.684660673141479 12.86974048614502 1.000000834465027 17.19580078125 1.000000834465027 C 21.52186012268066 1.000000834465027 25.58898162841797 2.684660673141479 28.6479606628418 5.743640899658203 C 31.70694160461426 8.802620887756348 33.3916015625 12.86974048614502 33.3916015625 17.19580078125 C 33.3916015625 21.52186012268066 31.70694160461426 25.58898162841797 28.6479606628418 28.6479606628418 C 25.58898162841797 31.70694160461426 21.52186012268066 33.3916015625 17.19580078125 33.3916015625 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.19580078125 2 C 13.13685035705566 2 9.320850372314453 3.58064079284668 6.450750350952148 6.450750350952148 C 3.58064079284668 9.320850372314453 2 13.13685035705566 2 17.19580078125 C 2 21.25475120544434 3.58064079284668 25.07075119018555 6.450750350952148 27.94085121154785 C 9.320850372314453 30.81096076965332 13.13685035705566 32.3916015625 17.19580078125 32.3916015625 C 21.25475120544434 32.3916015625 25.07075119018555 30.81096076965332 27.94085121154785 27.94085121154785 C 30.81096076965332 25.07075119018555 32.3916015625 21.25475120544434 32.3916015625 17.19580078125 C 32.3916015625 13.13685035705566 30.81096076965332 9.320850372314453 27.94085121154785 6.450750350952148 C 25.07075119018555 3.58064079284668 21.25475120544434 2 17.19580078125 2 M 17.19580078125 0 C 26.69278144836426 0 34.3916015625 7.698820114135742 34.3916015625 17.19580078125 C 34.3916015625 26.69278144836426 26.69278144836426 34.3916015625 17.19580078125 34.3916015625 C 7.698820114135742 34.3916015625 0 26.69278144836426 0 17.19580078125 C 0 7.698820114135742 7.698820114135742 0 17.19580078125 0 Z",
    stroke: "none",
    fill: "#ffd5d5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    transform: "translate(909 194)",
    fill: "#f26e14",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(916.729 197.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42727",
    "data-name": "Path 42727",
    d: "M16.914,16.249l-1.543-1.543,1.543-1.543a.468.468,0,1,0-.662-.662l-1.543,1.543L13.165,12.5a.468.468,0,0,0-.662.662l1.543,1.543L12.5,16.249a.452.452,0,0,0,0,.662.465.465,0,0,0,.662,0l1.543-1.543,1.543,1.543a.47.47,0,0,0,.662,0A.465.465,0,0,0,16.914,16.249Z",
    transform: "translate(-5.242 -5.239)",
    fill: "#b20000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42728",
    "data-name": "Path 42728",
    d: "M9.466,4.195A5.269,5.269,0,1,1,5.738,5.738,5.236,5.236,0,0,1,9.466,4.195m0-.82a6.091,6.091,0,1,0,6.091,6.091A6.09,6.09,0,0,0,9.466,3.375Z",
    fill: "#b20000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconRejected);
export default __webpack_public_path__ + "static/media/notification-icon-rejected.f34c46632b97f9c82599fc0ec595ebc1.svg";
export { ForwardRef as ReactComponent };